export type SquareIconProps = {
  size: number;
  strokeWidth?: number;
  color?: string;
};

export type RectangularIconProps = {
  width: number;
  height: number;
  size?: number;
  strokeWidth?: number;
  color?: string;
};

/**
 * Google Icon
 */
export type GoogleIconProps = RectangularIconProps;

export const GoogleIcon = ({
  width,
  height,
}: GoogleIconProps): JSX.Element => (
  <img height={height} width={width} src="https://coinmiles-assets.s3.ca-central-1.amazonaws.com/google-icon.svg"></img>
);

/*
  Password Show (open eye) Icon
*/
export type PasswordShowIconProps = SquareIconProps;

export const PasswordShowIcon = ({
  size = 28,
}: PasswordShowIconProps): JSX.Element => (
  <svg
    display="block"
    width={size}
    height={size * 0.857} // i.e. 28 x 24 aspect ratio
    viewBox="0 0 28 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M26.3829 10.5241C23.4047 7.61407 18.4651 4.53807 13.5109 4.60007C8.55662 4.53707 3.617 7.61507 0.638822 10.5241C0.23058 10.9294 0.00488281 11.4542 0.00488281 11.9981C0.00488281 12.5419 0.23058 13.0667 0.638822 13.4721C3.5821 16.3511 8.4519 19.4001 13.3296 19.4001H13.6764C18.571 19.4001 23.4396 16.3511 26.3863 13.4711C26.794 13.0655 27.0191 12.5407 27.0184 11.997C27.0178 11.4533 26.7915 10.9289 26.3829 10.5241ZM8.33142 12.0001C8.33142 11.0903 8.63519 10.2009 9.20432 9.44445C9.77344 8.68798 10.5824 8.09839 11.5288 7.75023C12.4752 7.40206 13.5166 7.31097 14.5213 7.48846C15.526 7.66595 16.4489 8.10406 17.1733 8.74738C17.8976 9.3907 18.3909 10.2103 18.5908 11.1027C18.7906 11.995 18.6881 12.9199 18.2961 13.7604C17.904 14.601 17.2402 15.3194 16.3884 15.8248C15.5367 16.3303 14.5353 16.6001 13.5109 16.6001C12.1372 16.6001 10.8198 16.1154 9.84845 15.2528C8.87712 14.3901 8.33142 13.2201 8.33142 12.0001Z"
        fill="#010621"
      />
      <path
        d="M11.2598 12C11.2598 12.5304 11.497 13.0391 11.9193 13.4142C12.3417 13.7893 12.9144 14 13.5117 14C14.1089 14 14.6817 13.7893 15.1041 13.4142C15.5264 13.0391 15.7636 12.5304 15.7636 12C15.7636 11.4696 15.5264 10.9609 15.1041 10.5858C14.6817 10.2107 14.1089 10 13.5117 10C12.9144 10 12.3417 10.2107 11.9193 10.5858C11.497 10.9609 11.2598 11.4696 11.2598 12Z"
        fill="#010621"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="27.0232" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

/*
  Password Hide (strike-through eye) Icon
*/
export type PasswordHideIconProps = SquareIconProps;

export const PasswordHideIcon = ({
  size = 28,
}: PasswordHideIconProps): JSX.Element => (
  <svg
    width={size}
    height={size * 0.857} // i.e. 28 x 24 aspect ratio
    viewBox="0 0 28 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M26.3829 10.524C23.4047 7.61401 18.4651 4.53801 13.5109 4.60001C8.55662 4.53701 3.617 7.61501 0.638822 10.524C0.23058 10.9294 0.00488281 11.4542 0.00488281 11.998C0.00488281 12.5419 0.23058 13.0666 0.638822 13.472C3.5821 16.351 8.4519 19.4 13.3296 19.4H13.6764C18.571 19.4 23.4396 16.351 26.3863 13.471C26.794 13.0654 27.0191 12.5406 27.0184 11.9969C27.0178 11.4533 26.7915 10.9288 26.3829 10.524ZM8.33142 12C8.33142 11.0902 8.63519 10.2009 9.20432 9.44439C9.77344 8.68792 10.5824 8.09833 11.5288 7.75017C12.4752 7.402 13.5166 7.31091 14.5213 7.4884C15.526 7.66589 16.4489 8.104 17.1733 8.74732C17.8976 9.39064 18.3909 10.2103 18.5908 11.1026C18.7906 11.9949 18.6881 12.9198 18.2961 13.7604C17.904 14.6009 17.2402 15.3193 16.3884 15.8248C15.5367 16.3302 14.5353 16.6 13.5109 16.6C12.1372 16.6 10.8198 16.1154 9.84845 15.2527C8.87712 14.39 8.33142 13.22 8.33142 12Z"
        fill="#010621"
      />
      <path
        d="M11.2595 12C11.2595 12.5304 11.4968 13.0391 11.9191 13.4142C12.3414 13.7893 12.9142 14 13.5115 14C14.1087 14 14.6815 13.7893 15.1038 13.4142C15.5261 13.0391 15.7634 12.5304 15.7634 12C15.7634 11.4696 15.5261 10.9609 15.1038 10.5858C14.6815 10.2107 14.1087 10 13.5115 10C12.9142 10 12.3414 10.2107 11.9191 10.5858C11.4968 10.9609 11.2595 11.4696 11.2595 12Z"
        fill="#010621"
      />
      <path
        d="M2.70711 0.792893C2.31658 0.402369 1.68342 0.402369 1.29289 0.792893C0.902369 1.18342 0.902369 1.81658 1.29289 2.20711L2.70711 0.792893ZM21.7929 22.7071C22.1834 23.0976 22.8166 23.0976 23.2071 22.7071C23.5976 22.3166 23.5976 21.6834 23.2071 21.2929L21.7929 22.7071ZM1.29289 2.20711L21.7929 22.7071L23.2071 21.2929L2.70711 0.792893L1.29289 2.20711Z"
        fill="#010621"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="27.0232" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

/*
  Home Icon
*/
export type HomeIconProps = SquareIconProps;

export const HomeIcon = ({ size = 24 }: HomeIconProps): JSX.Element => (
  <svg
    display="block"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.875 16.875V9.02655C16.875 8.93945 16.8568 8.85332 16.8215 8.77367C16.7863 8.69403 16.7348 8.62263 16.6703 8.56405L10.4203 2.66249C10.3052 2.55774 10.1552 2.49969 9.99961 2.49969C9.844 2.49969 9.69399 2.55774 9.57891 2.66249L3.32891 8.56405C3.26459 8.6227 3.21323 8.69413 3.17811 8.77377C3.143 8.85341 3.12491 8.93951 3.125 9.02655V16.875"
      stroke="#423333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.25 16.875H18.75"
      stroke="#423333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.875 16.875V12.5C11.875 12.3342 11.8092 12.1753 11.6919 12.0581C11.5747 11.9408 11.4158 11.875 11.25 11.875H8.75C8.58424 11.875 8.42527 11.9408 8.30806 12.0581C8.19085 12.1753 8.125 12.3342 8.125 12.5V16.875"
      stroke="#423333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/*
  Funnel Icon (for Online Affiliates)
*/
export type FunnelIconProps = SquareIconProps;

export const FunnelIcon = ({ size = 24 }: FunnelIconProps): JSX.Element => (
  <svg
    display="block"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z"
      stroke="#5D5151"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/*
  Credit Card Icon
*/
export type CreditCardIconProps = SquareIconProps;

export const CreditCardIcon = ({
  size = 24,
}: CreditCardIconProps): JSX.Element => (
  <svg
    display="block"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 4H3C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4Z"
      stroke="#5D5151"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 10H23"
      stroke="#5D5151"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/*
  Dollar Sign Icon
*/
export type DollarSignIconProps = SquareIconProps;

export const DollarSignIcon = ({
  size = 24,
}: DollarSignIconProps): JSX.Element => (
  <svg
    display="block"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1.875V18.125"
      stroke="#5D5151"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.375 6.875C14.375 6.46462 14.2942 6.05826 14.1371 5.67911C13.9801 5.29997 13.7499 4.95547 13.4597 4.66529C13.1695 4.37511 12.825 4.14492 12.4459 3.98788C12.0667 3.83083 11.6604 3.75 11.25 3.75H8.75C7.9212 3.75 7.12634 4.07924 6.54029 4.66529C5.95424 5.25134 5.625 6.0462 5.625 6.875C5.625 7.7038 5.95424 8.49866 6.54029 9.08471C7.12634 9.67076 7.9212 10 8.75 10H11.875C12.7038 10 13.4987 10.3292 14.0847 10.9153C14.6708 11.5013 15 12.2962 15 13.125C15 13.9538 14.6708 14.7487 14.0847 15.3347C13.4987 15.9208 12.7038 16.25 11.875 16.25H8.125C7.2962 16.25 6.50134 15.9208 5.91529 15.3347C5.32924 14.7487 5 13.9538 5 13.125"
      stroke="#5D5151"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/*
  Bitcoin Icon
*/
export type BitcoinIconProps = SquareIconProps;

export const BitcoinIcon = ({ size = 10 }: BitcoinIconProps): JSX.Element => (
  <svg
    display="block"
    width={size}
    height={size}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5.33252" cy="5.37549" r="4.40918" fill="#FF9900" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.96719 4.98974C5.96791 4.99356 5.96862 4.99738 5.96934 5.0012C6.06168 4.98425 6.15714 4.97715 6.24576 4.94849C6.51868 4.86024 6.62943 4.52347 6.46904 4.28359C6.38695 4.16083 6.26517 4.08987 6.13556 4.03077C5.94168 3.94234 5.73465 3.89857 5.52897 3.84983C5.48589 3.83962 5.46908 3.84736 5.45821 3.89278C5.38964 4.17937 5.31798 4.46521 5.24735 4.7513C5.2226 4.85151 5.22238 4.85251 5.32207 4.87923C5.53372 4.93595 5.7462 4.98836 5.96719 4.98974ZM5.09667 5.37206C5.09202 5.38578 5.08857 5.39399 5.08646 5.40252C4.99963 5.75302 4.91324 6.10361 4.82567 6.45391C4.81801 6.48455 4.82985 6.49409 4.85588 6.50089C5.10828 6.56686 5.36038 6.63446 5.62179 6.654C5.76453 6.66467 5.9064 6.66141 6.04523 6.61986C6.36517 6.52413 6.49017 6.15213 6.29144 5.88341C6.21916 5.78567 6.12155 5.71794 6.01628 5.66119C5.78518 5.5366 5.53354 5.47382 5.28102 5.41397C5.22025 5.39956 5.15923 5.38625 5.09667 5.37206ZM4.145 6.96915C3.80492 6.88266 3.47002 6.79749 3.12793 6.71049C3.14707 6.66539 3.16382 6.62555 3.18084 6.58584C3.24092 6.44571 3.30188 6.30596 3.36059 6.16526C3.3736 6.13406 3.3887 6.12548 3.42172 6.1344C3.52877 6.16338 3.63613 6.19159 3.74433 6.21572C3.87249 6.2443 3.95339 6.19196 3.98534 6.06317C4.17009 5.31836 4.3546 4.5735 4.53873 3.82853C4.56881 3.70682 4.51212 3.58517 4.38965 3.53718C4.28693 3.49693 4.17752 3.4739 4.07085 3.44407C4.03073 3.43285 3.98998 3.42397 3.94373 3.41259C3.95694 3.35658 3.96894 3.30416 3.98171 3.25193C4.00896 3.1405 4.03797 3.02947 4.06335 2.91761C4.07221 2.87856 4.08481 2.8663 4.12712 2.87713C4.4349 2.95582 4.74354 3.03104 5.05141 3.10937C5.08956 3.11907 5.10082 3.10783 5.10941 3.07244C5.1696 2.82454 5.23263 2.57732 5.29204 2.32923C5.30113 2.29134 5.31502 2.28339 5.35005 2.2925C5.49077 2.32906 5.63173 2.36469 5.77304 2.39887C5.80657 2.40698 5.8106 2.42174 5.80262 2.45341C5.74278 2.69079 5.68477 2.92865 5.62627 3.16637C5.62161 3.1853 5.61748 3.20436 5.61173 3.22935C5.64228 3.23723 5.67052 3.24491 5.69894 3.25176C5.78781 3.27317 5.87732 3.29225 5.96544 3.31641C6.0021 3.32646 6.01516 3.3169 6.02374 3.28134C6.08049 3.04635 6.13899 2.81179 6.19668 2.57704C6.21282 2.51135 6.21257 2.51071 6.27614 2.52638C6.41004 2.55941 6.54368 2.59351 6.67769 2.62612C6.70931 2.63381 6.72163 2.64484 6.71219 2.682C6.64895 2.9309 6.58902 3.18067 6.52624 3.42969C6.51704 3.46619 6.52356 3.48182 6.56057 3.49499C6.76171 3.56664 6.95684 3.65176 7.13169 3.77762C7.32949 3.92001 7.48814 4.09552 7.52353 4.34652C7.57095 4.68295 7.49826 4.98791 7.24077 5.22728C7.15563 5.30643 7.05084 5.35268 6.94102 5.3871C6.92746 5.39135 6.91402 5.39601 6.8942 5.40259C6.95099 5.43846 7.00266 5.46825 7.05136 5.50234C7.35894 5.71767 7.48043 6.01175 7.41377 6.38379C7.37683 6.58993 7.30728 6.78401 7.19063 6.95822C7.03136 7.19609 6.80434 7.32738 6.52743 7.37662C6.27302 7.42187 6.01964 7.40131 5.76666 7.36334C5.71333 7.35533 5.65971 7.34808 5.60722 7.33608C5.57257 7.32816 5.55981 7.33862 5.55165 7.37237C5.49164 7.62062 5.42994 7.86846 5.36872 8.11642C5.35444 8.17427 5.35435 8.17431 5.29773 8.16017C5.16103 8.126 5.02461 8.09061 4.88747 8.05831C4.85122 8.04977 4.84744 8.03382 4.85565 8.00108C4.91704 7.75628 4.97593 7.51084 5.03827 7.26628C5.04895 7.22437 5.0417 7.20698 4.99904 7.19699C4.89841 7.17344 4.79839 7.14691 4.69896 7.11854C4.6619 7.10798 4.64867 7.11937 4.64004 7.15499C4.58061 7.40019 4.51859 7.64477 4.45989 7.89014C4.4496 7.93316 4.43634 7.94576 4.39089 7.93322C4.25515 7.89574 4.1182 7.86258 3.98113 7.83027C3.9434 7.82137 3.93871 7.80479 3.94753 7.7698C4.00921 7.52512 4.06908 7.27996 4.12948 7.03494C4.13415 7.01602 4.13844 6.99702 4.145 6.96915Z"
      fill="white"
    />
  </svg>
);

/*
  Pin Marker Icon
*/
export type PinMarkerIconProps = SquareIconProps;

export const PinMarkerIcon = ({
  size = 10,
}: PinMarkerIconProps): JSX.Element => (
  <svg
    display="block"
    width={size}
    height={size}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M5.3324 0.73877C4.40696 0.739839 3.51973 1.10794 2.86535 1.76232C2.21097 2.41671 1.84287 3.30393 1.8418 4.22937C1.8418 6.63495 4.24407 8.81786 4.98003 9.42963C5.07898 9.51184 5.20357 9.55683 5.33221 9.55683C5.46086 9.55683 5.58545 9.51184 5.6844 9.42963C6.41926 8.81786 8.823 6.63421 8.823 4.229C8.82183 3.30363 8.45369 2.4165 7.79931 1.76219C7.14494 1.10789 6.25777 0.739839 5.3324 0.73877V0.73877ZM5.3324 6.06653C4.96904 6.06653 4.61385 5.95878 4.31173 5.75691C4.00961 5.55504 3.77414 5.26812 3.63508 4.93242C3.49603 4.59672 3.45965 4.22733 3.53054 3.87096C3.60143 3.51459 3.7764 3.18724 4.03333 2.9303C4.29026 2.67337 4.61761 2.4984 4.97399 2.42751C5.33036 2.35663 5.69975 2.39301 6.03545 2.53206C6.37114 2.67111 6.65807 2.90658 6.85994 3.2087C7.06181 3.51082 7.16956 3.86602 7.16956 4.22937C7.16956 4.47063 7.12204 4.70953 7.02971 4.93242C6.93739 5.15532 6.80206 5.35784 6.63147 5.52844C6.46087 5.69903 6.25834 5.83436 6.03545 5.92668C5.81255 6.01901 5.57366 6.06653 5.3324 6.06653V6.06653Z"
        fill="#010621"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="8.81836"
          height="8.81836"
          fill="white"
          transform="translate(0.92334 0.73877)"
        />
      </clipPath>
    </defs>
  </svg>
);

/*
  Down Chevron Icon
*/
export type ChevronDownIconProps = RectangularIconProps;

export const ChevronDownIcon = ({
  width,
  height,
}: ChevronDownIconProps): JSX.Element => {
  return (
    <svg
      display="block"
      width={width}
      height={height}
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L5 5L9 1"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

/*
  Sign Out Icon
*/
export type SignOutIconProps = SquareIconProps;

export const SignOutIcon = ({
  size = 24,
}: SignOutIconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.125 3.125H3.75C3.58424 3.125 3.42527 3.19085 3.30806 3.30806C3.19085 3.42527 3.125 3.58424 3.125 3.75V16.25C3.125 16.4158 3.19085 16.5747 3.30806 16.6919C3.42527 16.8092 3.58424 16.875 3.75 16.875H8.125"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.125 10H16.875"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 6.875L16.875 10L13.75 13.125"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />      
    </svg>
  );
};

/*
  Back Arrow Icon
*/
export type BackArrowIconProps = SquareIconProps;

export const BackArrowIcon = ({
  size = 24,
}: BackArrowIconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 12H5"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 19L5 12L12 5"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

/*
  Forward Arrow Icon
*/
export type ForwardArrowIconProps = SquareIconProps;

export const ForwardArrowIcon = ({
  size = 16,
}: ForwardArrowIconProps): JSX.Element => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33301 8.5H12.6663"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 3.83331L12.6667 8.49998L8 13.1666"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/*
  Upload Cloud Icon
*/
export type UploadCloudIconProps = SquareIconProps;

export const UploadCloudIcon = ({
  size = 54,
}: UploadCloudIconProps): JSX.Element => (
  <svg
    width={size}
    height={size * 0.852} // 54 x 46 aspect ratio
    viewBox="0 0 54 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0732 34.7368H25.2788V23.2012L25.4106 20.2349L24.1362 21.6191L21.082 24.8931C20.7524 25.2446 20.269 25.4204 19.8296 25.4204C18.9067 25.4204 18.2036 24.7612 18.2036 23.8384C18.2036 23.377 18.4014 23.0034 18.731 22.6738L25.7402 15.9062C26.2017 15.4448 26.6191 15.291 27.0806 15.291C27.542 15.291 27.9595 15.4448 28.4209 15.9062L35.4302 22.6738C35.7598 23.0034 35.9575 23.377 35.9575 23.8384C35.9575 24.7612 35.2324 25.4204 34.3096 25.4204C33.8701 25.4204 33.3867 25.2446 33.0791 24.8931L30.0249 21.6191L28.7505 20.2349L28.8823 23.2012V34.7368H43.1426C49.1851 34.7368 53.272 31.0015 53.272 25.9697C53.272 21.8169 50.7451 18.0815 46.6582 16.3896C46.7021 7.07324 40.0005 0.349609 31.4312 0.349609C25.8281 0.349609 21.7632 3.31592 19.2363 7.00732C14.4243 5.73291 8.51367 9.42432 8.35986 15.269C3.65771 16.0601 0.713379 20.2129 0.713379 25.0469C0.713379 30.4302 5.21777 34.7368 12.0732 34.7368ZM27.0806 45.4155C28.0254 45.4155 28.8164 44.6245 28.8164 43.7017V34.0776C28.7725 34.9346 28.0254 35.7036 27.0806 35.7036C26.1357 35.7036 25.3887 34.9346 25.3228 34.0776V43.7017C25.3228 44.6245 26.1138 45.4155 27.0806 45.4155Z"
      fill="#CCCDD3"
    />
  </svg>
);

/*
  Check Circle Filled Icon
*/
export type CheckCircleFilledIconProps = SquareIconProps;

export const CheckCircleFilledIcon = ({
  size = 13,
}: CheckCircleFilledIconProps): JSX.Element => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4967 6.27711 13.8108 4.62573 12.5925 3.40746C11.3743 2.18918 9.72289 1.5033 8 1.5ZM11.0938 6.8625L7.43125 10.3625C7.33657 10.4516 7.21125 10.5008 7.08125 10.5C7.01771 10.5009 6.95463 10.4892 6.89563 10.4656C6.83663 10.442 6.78289 10.407 6.7375 10.3625L4.90625 8.6125C4.85546 8.56819 4.81415 8.51406 4.78481 8.45337C4.75547 8.39269 4.73871 8.3267 4.73552 8.25937C4.73233 8.19204 4.7428 8.12476 4.76628 8.06157C4.78975 7.99839 4.82577 7.9406 4.87215 7.89169C4.91853 7.84278 4.97432 7.80375 5.03617 7.77695C5.09802 7.75015 5.16465 7.73614 5.23206 7.73574C5.29946 7.73535 5.36625 7.7486 5.42841 7.77467C5.49056 7.80075 5.54681 7.83913 5.59375 7.8875L7.08125 9.30625L10.4063 6.1375C10.5035 6.05268 10.6297 6.00872 10.7586 6.01482C10.8875 6.02092 11.009 6.0766 11.0978 6.17022C11.1866 6.26384 11.2357 6.38815 11.235 6.51717C11.2342 6.64618 11.1836 6.76992 11.0938 6.8625Z"
      fill="black"
    />
  </svg>
);

/**
 * Users Icon
 */
export type UsersIconProps = SquareIconProps;

export const UsersIcon = ({ size }: UsersIconProps): JSX.Element => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5625 12.5C8.80616 12.5 10.625 10.6812 10.625 8.4375C10.625 6.19384 8.80616 4.375 6.5625 4.375C4.31884 4.375 2.5 6.19384 2.5 8.4375C2.5 10.6812 4.31884 12.5 6.5625 12.5Z"
      stroke="#5C5151"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.799316 15.625C1.42361 14.6651 2.27775 13.8764 3.28421 13.3304C4.29067 12.7844 5.41757 12.4984 6.5626 12.4984C7.70763 12.4984 8.83452 12.7844 9.84098 13.3304C10.8474 13.8764 11.7016 14.6651 12.3259 15.625"
      stroke="#5C5151"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.4375 12.5C14.5825 12.4993 15.7095 12.7849 16.716 13.3306C17.7225 13.8764 18.5767 14.6651 19.2008 15.625"
      stroke="#5C5151"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9287 4.66406C12.4844 4.44242 13.0822 4.34625 13.6794 4.38244C14.2766 4.41862 14.8584 4.58626 15.3833 4.87338C15.9082 5.16051 16.3632 5.56002 16.7158 6.04337C17.0684 6.52672 17.3099 7.08198 17.423 7.66948C17.5361 8.25698 17.518 8.86221 17.3701 9.44192C17.2222 10.0216 16.948 10.5615 16.5673 11.023C16.1865 11.4845 15.7085 11.8562 15.1674 12.1115C14.6264 12.3668 14.0356 12.4995 13.4373 12.5"
      stroke="#5C5151"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Gift Icon
 */
export type GiftIconProps = SquareIconProps;

export const GiftIcon = ({ size, color = "#000000" }: GiftIconProps): JSX.Element => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 5.86328C1 4.75871 1.89543 3.86328 3 3.86328H21C22.1046 3.86328 23 4.75871 23 5.86328V18.8633C23 19.9679 22.1046 20.8633 21 20.8633H3C1.89543 20.8633 1 19.9679 1 18.8633V5.86328ZM10.5 5.36328H21C21.2761 5.36328 21.5 5.58714 21.5 5.86328V9.97852L14.8215 9.97852C14.8153 9.94507 14.8085 9.91172 14.801 9.87849C14.6596 9.25422 14.2855 8.69533 13.7408 8.33284C13.1932 7.96845 12.5151 7.83272 11.8571 7.98169C11.2893 8.11024 10.8453 8.38623 10.5 8.7132V5.36328ZM9 5.36328H3C2.72386 5.36328 2.5 5.58714 2.5 5.86328V9.97852H4.86559C4.87838 9.90624 4.89432 9.83441 4.91339 9.76324C5.07905 9.14499 5.47475 8.60118 6.03328 8.26029C6.59473 7.91761 7.27756 7.80853 7.92925 7.98315C8.35678 8.09771 8.70948 8.29462 9 8.53196V5.36328ZM9 11.8803C8.98858 11.7613 8.8921 10.8823 8.47829 10.2008C8.26282 9.84597 7.96133 9.54466 7.54102 9.43204C7.29704 9.36667 7.03579 9.40574 6.81473 9.54066C6.59367 9.67558 6.43092 9.89529 6.36227 10.1515C6.29363 10.4077 6.32472 10.6793 6.4487 10.9067C6.57269 11.1341 6.7794 11.2985 7.02339 11.3639L9 11.8935V11.8803ZM9 14.4937L6.98366 16.5866C6.69627 16.8849 6.22148 16.8937 5.92318 16.6063C5.62489 16.319 5.61604 15.8442 5.90343 15.5459L8.14643 13.2177L6.63516 12.8128C5.98346 12.6382 5.44666 12.2023 5.13176 11.6248C5.10552 11.5767 5.08098 11.5279 5.05814 11.4785H2.5V18.8633C2.5 19.1394 2.72386 19.3633 3 19.3633H9V14.4937ZM10.5 19.3633H21C21.2761 19.3633 21.5 19.1394 21.5 18.8633V11.4785L14.6413 11.4785C14.6025 11.5643 14.5587 11.6483 14.5099 11.7301C14.1726 12.2948 13.6192 12.7093 12.9611 12.8583L11.7676 13.1285L14.0966 15.5459C14.384 15.8442 14.3751 16.319 14.0768 16.6063C13.7785 16.8937 13.3037 16.8849 13.0163 16.5866L10.5 13.9747V19.3633ZM10.6328 11.8474C10.6328 11.8474 10.7486 10.8907 11.2217 10.1762C11.4509 9.83002 11.7639 9.54075 12.1883 9.44466C12.4347 9.38889 12.6942 9.43816 12.9098 9.58163C13.1254 9.7251 13.2794 9.95102 13.338 10.2097C13.3966 10.4684 13.3549 10.7386 13.2221 10.9609C13.0893 11.1833 12.8763 11.3395 12.6299 11.3953L10.6328 11.8474Z"
      fillRule="evenodd" 
      clipRule="evenodd"
      fill={color}
    />
  
    {/*  Note: old gift box icon
    <path
      d="M20 12V22H4V12"
      stroke="#5C5151"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 7H2V12H22V7Z"
      stroke="#5C5151"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 22V7"
      stroke="#5C5151"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 7H7.5C6.83696 7 6.20107 6.73661 5.73223 6.26777C5.26339 5.79893 5 5.16304 5 4.5C5 3.83696 5.26339 3.20107 5.73223 2.73223C6.20107 2.26339 6.83696 2 7.5 2C11 2 12 7 12 7Z"
      stroke="#5C5151"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 7H16.5C17.163 7 17.7989 6.73661 18.2678 6.26777C18.7366 5.79893 19 5.16304 19 4.5C19 3.83696 18.7366 3.20107 18.2678 2.73223C17.7989 2.26339 17.163 2 16.5 2C13 2 12 7 12 7Z"
      stroke="#5C5151"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    /> */}
  </svg>
);

/**
 * User Icon (old icon for Organization)
 */
export type UserIconProps = SquareIconProps;

export const UserIcon = ({ size }: UserIconProps): JSX.Element => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
      stroke="#423333"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
      stroke="#423333"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * User Icon
 */
export type OrganizationIconProps = SquareIconProps;

export const OrganizationIcon = ({ size }: OrganizationIconProps): JSX.Element => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.625 16.875V2.50001C10.6249 2.38689 10.5942 2.27592 10.536 2.17892C10.4778 2.08191 10.3944 2.00252 10.2946 1.94919C10.1949 1.89587 10.0825 1.87061 9.96956 1.87612C9.85658 1.88163 9.74722 1.9177 9.65313 1.98048L3.40313 6.14688C3.3174 6.20408 3.24715 6.28158 3.19862 6.3725C3.1501 6.46342 3.12481 6.56492 3.125 6.66798V16.875"
      stroke="#423333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.625 6.875H16.25C16.4158 6.875 16.5747 6.94085 16.6919 7.05806C16.8092 7.17527 16.875 7.33424 16.875 7.5V16.875"
      stroke="#423333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.25 16.875H18.75"
      stroke="#423333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.125 8.75V10"
      stroke="#423333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.625 8.75V10"
      stroke="#423333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.625 13.125V14.375"
      stroke="#423333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.125 13.125V14.375"
      stroke="#423333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />                    
  </svg>
);

/**
 * User Icon (old icon for Organization)
 */
export type RocketIconProps = SquareIconProps;

export const RocketIcon = ({ size = 24, strokeWidth = 1.5 }: RocketIconProps): JSX.Element => (
  <svg
    width={size}
    height={size}
    strokeWidth={strokeWidth}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 14.375C7.5 14.375 6.875 16.875 3.125 16.875C3.125 13.125 5.625 12.5 5.625 12.5"
      stroke="#423333"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.9305 8.81953C16.8055 6.94453 16.9227 4.71407 16.8641 3.71953C16.8543 3.56796 16.7897 3.42511 16.6823 3.31771C16.5749 3.21031 16.432 3.14569 16.2805 3.13594C15.2859 3.07735 13.057 3.19297 11.1805 5.06953L6.25 10L10 13.75L14.9305 8.81953Z"
      stroke="#423333"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.625 5.625H5.80855C5.64301 5.62508 5.48426 5.69082 5.36714 5.80781L2.68355 8.49141C2.60162 8.57352 2.54415 8.67682 2.51759 8.78974C2.49102 8.90265 2.49641 9.02074 2.53314 9.13077C2.56987 9.2408 2.6365 9.33844 2.72556 9.41275C2.81463 9.48707 2.92263 9.53513 3.03746 9.55156L6.24996 10"
      stroke="#423333"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.375 9.375V14.1914C14.3749 14.3569 14.3092 14.5157 14.1922 14.6328L11.5086 17.3164C11.4265 17.3983 11.3232 17.4558 11.2103 17.4824C11.0973 17.5089 10.9793 17.5035 10.8692 17.4668C10.7592 17.4301 10.6616 17.3635 10.5872 17.2744C10.5129 17.1853 10.4649 17.0773 10.4484 16.9625L10 13.75"
      stroke="#423333"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />        
  </svg>
);

/**
 * EmptyImage Icon
 */
export type EmptyImageIconProps = SquareIconProps;

export const EmptyImageIcon = ({ size }: EmptyImageIconProps): JSX.Element => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41.8438 10.0942H8.15625C7.31056 10.0942 6.625 10.7797 6.625 11.6254V39.1879C6.625 40.0336 7.31056 40.7192 8.15625 40.7192H41.8438C42.6894 40.7192 43.375 40.0336 43.375 39.1879V11.6254C43.375 10.7797 42.6894 10.0942 41.8438 10.0942Z"
      stroke="#9C9794"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.3594 22.3442C31.6279 22.3442 32.6562 21.3158 32.6562 20.0473C32.6562 18.7788 31.6279 17.7504 30.3594 17.7504C29.0908 17.7504 28.0625 18.7788 28.0625 20.0473C28.0625 21.3158 29.0908 22.3442 30.3594 22.3442Z"
      stroke="#9C9794"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
      <path
      d="M28.6973 32.2973L33.6145 27.3858C33.9016 27.0989 34.291 26.9377 34.6969 26.9377C35.1028 26.9377 35.4922 27.0989 35.7793 27.3858L43.3762 34.9885" 
      stroke="#9C9794"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
      <path
      d="M6.625 33.195L17.026 22.7921C17.1682 22.6497 17.3371 22.5368 17.523 22.4597C17.7089 22.3826 17.9081 22.343 18.1094 22.343C18.3106 22.343 18.5099 22.3826 18.6958 22.4597C18.8816 22.5368 19.0505 22.6497 19.1927 22.7921L37.1179 40.7192"
      stroke="#9C9794"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />    
  </svg>
);

/*
  Star Icon
*/
export type StarIconProps = SquareIconProps;

export const StarIcon = ({
  size,
  color = "#000000",
  strokeWidth = 1.5
}: StarIconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_272_3320)">
        <path
          d="M12.6878 2.70951L14.8656 7.89951C14.9183 8.02547 15.0044 8.13464 15.1146 8.21526C15.2248 8.29589 15.3549 8.3449 15.4909 8.35701L21.0653 8.83889C21.2132 8.85077 21.3543 8.90627 21.4706 8.99835C21.587 9.09043 21.6734 9.21495 21.719 9.35616C21.7645 9.49738 21.7672 9.64893 21.7266 9.79166C21.686 9.93438 21.604 10.0619 21.4909 10.1579L17.2619 13.847C17.1591 13.9373 17.0827 14.0538 17.0407 14.184C16.9988 14.3142 16.9929 14.4534 17.0237 14.5867L18.2912 20.0748C18.3247 20.2182 18.3153 20.3682 18.2641 20.5062C18.213 20.6442 18.1223 20.7641 18.0035 20.851C17.8846 20.9379 17.7428 20.9878 17.5958 20.9947C17.4488 21.0015 17.303 20.965 17.1766 20.8895L12.3859 17.9833C12.2695 17.9125 12.1359 17.875 11.9997 17.875C11.8634 17.875 11.7298 17.9125 11.6134 17.9833L6.8228 20.8895C6.6964 20.965 6.55059 21.0015 6.40355 20.9947C6.25651 20.9878 6.11473 20.9379 5.99589 20.851C5.87704 20.7641 5.78639 20.6442 5.73522 20.5062C5.68404 20.3682 5.67462 20.2182 5.70811 20.0748L6.97561 14.5867C7.00642 14.4534 7.00055 14.3142 6.95863 14.184C6.9167 14.0538 6.84028 13.9373 6.73749 13.847L2.50843 10.1579C2.39536 10.0619 2.31335 9.93438 2.27275 9.79166C2.23216 9.64893 2.23481 9.49738 2.28038 9.35616C2.32594 9.21495 2.41237 9.09043 2.52873 8.99835C2.64509 8.90627 2.78615 8.85077 2.93405 8.83889L8.50843 8.35701C8.64443 8.3449 8.77454 8.29589 8.88474 8.21526C8.99493 8.13464 9.08103 8.02547 9.13374 7.89951L11.3116 2.70951C11.3697 2.57533 11.4658 2.46108 11.5881 2.38083C11.7104 2.30057 11.8534 2.25781 11.9997 2.25781C12.1459 2.25781 12.289 2.30057 12.4112 2.38083C12.5335 2.46108 12.6296 2.57533 12.6878 2.70951Z"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>    
      <defs>
        <clipPath id="clip0_272_3320">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

/*
  Airplane Icon
*/
export type AirplaneIconProps = SquareIconProps;

export const AirplaneIcon = ({
  size,
  color = "#000000",
  strokeWidth = 1.5
}: AirplaneIconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_272_3320)">
        <path
          d="M8.65039 21L10.9004 18.75V16.5L13.1504 14.25L17.6504 21L19.9004 18.75L16.9004 10.5L19.9941 7.59375C20.4168 7.17106 20.6543 6.59777 20.6543 6C20.6543 5.40222 20.4168 4.82894 19.9941 4.40625C19.5715 3.98356 18.9982 3.74609 18.4004 3.74609C17.8026 3.74609 17.2293 3.98356 16.8066 4.40625L13.9004 7.5L5.65039 4.5L3.40039 6.75L10.1504 11.25L7.90039 13.5H5.65039L3.40039 15.75L7.15039 17.25L8.65039 21Z"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>    
      <defs>
        <clipPath id="clip0_272_3320">
          <rect width="25" height="24" fill="white" transform="translate(0.400391)" />
        </clipPath>
      </defs>
    </svg>
  );
};

/*
  Barchart Icon
*/
export type BarchartIconProps = SquareIconProps;

export const BarchartIcon = ({
  size,
  color = "#000000",
  strokeWidth = 1.5
}: BarchartIconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_272_3320)">
        <path d="M5.30078 19.5V12.75H9.80078" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M21.8008 19.5H3.80078" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9.80078 19.5V8.25H15.0508" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M15.0508 19.5V3.75H20.3008V19.5" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>  
      </g>    
      <defs>
        <clipPath id="clip0_272_3320">
          <rect width="25" height="24" fill="white" transform="translate(0.400391)" />
        </clipPath>
      </defs>
    </svg>
  );
};

// =================

// =================

// =================

// =================

/*
  Airdrops Icon
*/
export type AirdropIconProps = SquareIconProps;

export const AirdropIcon = ({
  size,
  color = "#000000",
  strokeWidth = 1.5
}: AirdropIconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_272_3320)">
        <circle cx="12" cy="12" r="10.25" stroke={color} strokeWidth={strokeWidth} />
        <circle cx="12" cy="12" r="6.25" stroke={color} strokeWidth={strokeWidth} />
        <circle cx="12" cy="12" r="2.25" stroke={color} strokeWidth={strokeWidth} />
        <circle cx="9.00006" cy="6.71881" stroke={color} strokeWidth={strokeWidth} />
        <circle cx="21.9688" cy="10.1564" stroke={color} strokeWidth={strokeWidth} />  
        <circle cx="5.00006" cy="19.6875" stroke={color} strokeWidth={strokeWidth} />  
      </g>    
      <defs>
        <clipPath id="clip0_272_3320">
          <rect width="25" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

/*
  Cake Icon
*/
export type CakeIconProps = SquareIconProps;

export const CakeIcon = ({
  size,
  color = "#000000",
  strokeWidth = 1.5
}: CakeIconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_272_3320)">
        <path d="M12 8.09375V10.3438" stroke={color} strokeWidth={strokeWidth * 1.3} strokeLinecap="round" strokeLinejoin="round"/>  
        <path d="M4.5 11.0938H19.5C19.8978 11.0938 20.2794 11.2518 20.5607 11.5331C20.842 11.8144 21 12.1959 21 12.5938V14.7809C21 16.4159 19.7184 17.7978 18.0844 17.8428C17.6834 17.8541 17.2843 17.7849 16.9106 17.6392C16.5369 17.4936 16.1962 17.2745 15.9086 16.9949C15.6211 16.7152 15.3925 16.3808 15.2364 16.0113C15.0804 15.6419 15 15.2448 15 14.8438C15 15.6394 14.6839 16.4025 14.1213 16.9651C13.5587 17.5277 12.7956 17.8438 12 17.8438C11.2044 17.8438 10.4413 17.5277 9.87868 16.9651C9.31607 16.4025 9 15.6394 9 14.8438C9.00016 15.2449 8.91986 15.642 8.76384 16.0116C8.60783 16.3812 8.37928 16.7158 8.0917 16.9955C7.80413 17.2752 7.46338 17.4944 7.0896 17.6401C6.71583 17.7858 6.31663 17.855 5.91562 17.8438C4.28156 17.7978 3 16.4159 3 14.7809V12.5938C3 12.1959 3.15804 11.8144 3.43934 11.5331C3.72064 11.2518 4.10218 11.0937 4.5 11.0938Z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M20.25 16.8031V20.8438C20.25 21.2416 20.092 21.6231 19.8107 21.9044C19.5294 22.1857 19.1478 22.3438 18.75 22.3438H5.25C4.85218 22.3438 4.47064 22.1857 4.18934 21.9044C3.90804 21.6231 3.75 21.2416 3.75 20.8438V16.8031" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.25 5.40625C14.25 6.00299 14.0129 6.57528 13.591 6.99724C13.169 7.4192 12.5967 7.65625 12 7.65625C11.4033 7.65625 10.831 7.4192 10.409 6.99724C9.98705 6.57528 9.75 6.00299 9.75 5.40625C9.75 3.15625 12 1.65625 12 1.65625C12 1.65625 14.25 3.15625 14.25 5.40625Z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
      </g>    
      <defs>
        <clipPath id="clip0_272_3320">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

/*
  OnTheGo Icon
*/
export type OnTheGoIconProps = SquareIconProps;

export const OnTheGoIcon = ({
  size,
  color = "#000000",
  strokeWidth = 1.5
}: OnTheGoIconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_272_3320)">
        <path d="M19.125 11C20.5747 11 21.75 9.82475 21.75 8.375C21.75 6.92525 20.5747 5.75 19.125 5.75C17.6753 5.75 16.5 6.92525 16.5 8.375C16.5 9.82475 17.6753 11 19.125 11Z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4.5 20H1.5C1.30109 20 1.11032 19.921 0.96967 19.7803C0.829018 19.6397 0.75 19.4489 0.75 19.25V15.5C0.75 15.3011 0.829018 15.1103 0.96967 14.9697C1.11032 14.829 1.30109 14.75 1.5 14.75H4.5" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10.5 15.5H13.5L19.7812 14.0553C20.0122 13.992 20.2546 13.9829 20.4897 14.0285C20.7247 14.0741 20.9461 14.1734 21.1365 14.3185C21.327 14.4636 21.4814 14.6507 21.5878 14.8652C21.6942 15.0797 21.7497 15.3159 21.75 15.5553C21.7501 15.8444 21.6697 16.1279 21.5176 16.3738C21.3656 16.6197 21.148 16.8184 20.8894 16.9475L17.25 18.5L11.25 20H4.5V14.75L6.84375 12.4063C7.05324 12.1975 7.30182 12.0321 7.5753 11.9195C7.84877 11.8069 8.14175 11.7493 8.4375 11.75H13.125C13.6223 11.75 14.0992 11.9476 14.4508 12.2992C14.8025 12.6508 15 13.1277 15 13.625C15 14.1223 14.8025 14.5992 14.4508 14.9508C14.0992 15.3025 13.6223 15.5 13.125 15.5H10.5Z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16.5012 8.49591C15.9917 8.73687 15.4183 8.80746 14.8656 8.69724C14.3129 8.58703 13.8103 8.30186 13.4322 7.88391C13.0542 7.46597 12.8206 6.93744 12.7662 6.3765C12.7117 5.81556 12.8393 5.25199 13.1299 4.76914C13.4206 4.28629 13.8589 3.90981 14.3801 3.69537C14.9013 3.48093 15.4777 3.43993 16.024 3.57841C16.5703 3.7169 17.0575 4.02753 17.4136 4.46437C17.7696 4.9012 17.9757 5.44104 18.0012 6.00404" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>  
      </g>    
      <defs>
        <clipPath id="clip0_272_3320">
          <rect width="24" height="25" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

/*
  RoundUp Icon
*/
export type RoundUpIconProps = SquareIconProps;

export const RoundUpIcon = ({
  size,
  color = "#000000",
  strokeWidth = 1.5
}: RoundUpIconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_272_3320)">
        <path d="M12.75 8L8.25 3.5L3.75 8"stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M18.75 8V16.25C18.75 17.6424 18.1969 18.9777 17.2123 19.9623C16.2277 20.9469 14.8924 21.5 13.5 21.5C12.1076 21.5 10.7723 20.9469 9.78769 19.9623C8.80312 18.9777 8.25 17.6424 8.25 16.25V3.5" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
      </g>    
      <defs>
        <clipPath id="clip0_272_3320">
          <rect width="25" height="24" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

/*
 PaymentCard Icon
*/
export type PaymentCardIconProps = SquareIconProps;

export const PaymentCardIcon = ({
  size,
  color = "#000000",
  strokeWidth = 1.5
}: PaymentCardIconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_272_3320)">
        <path d="M21 5.75H3C2.58579 5.75 2.25 6.08579 2.25 6.5V18.5C2.25 18.9142 2.58579 19.25 3 19.25H21C21.4142 19.25 21.75 18.9142 21.75 18.5V6.5C21.75 6.08579 21.4142 5.75 21 5.75Z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M15.75 16.25H18.75" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.25 16.25H12.75" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2.25 9.5H21.75" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
      </g>    
      <defs>
        <clipPath id="clip0_272_3320">
          <rect width="25" height="24" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

/*
  Integration Icon
*/
export type IntegrationIconProps = SquareIconProps;

export const IntegrationIcon = ({
  size,
  color = "#000000",
  strokeWidth = 1.5
}: IntegrationIconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_272_3320)">
        <path d="M12 10.25V12.5H5.25C4.65326 12.5 4.08097 12.2629 3.65901 11.841C3.23705 11.419 3 10.8467 3 10.25C3 9.65326 3.23705 9.08097 3.65901 8.65901C4.08097 8.23705 4.65326 8 5.25 8H9.75C10.3467 8 10.919 8.23705 11.341 8.65901C11.7629 9.08097 12 9.65326 12 10.25Z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 8H9.75C9.15326 8 8.58097 7.76295 8.15901 7.34099C7.73705 6.91903 7.5 6.34674 7.5 5.75C7.5 5.15326 7.73705 4.58097 8.15901 4.15901C8.58097 3.73705 9.15326 3.5 9.75 3.5C10.3467 3.5 10.919 3.73705 11.341 4.15901C11.7629 4.58097 12 5.15326 12 5.75V8Z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.25 12.5H12V5.75C12 5.15326 12.2371 4.58097 12.659 4.15901C13.081 3.73705 13.6533 3.5 14.25 3.5C14.8467 3.5 15.419 3.73705 15.841 4.15901C16.2629 4.58097 16.5 5.15326 16.5 5.75V10.25C16.5 10.8467 16.2629 11.419 15.841 11.841C15.419 12.2629 14.8467 12.5 14.25 12.5Z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16.5 12.5V10.25C16.5 9.65326 16.7371 9.08097 17.159 8.65901C17.581 8.23705 18.1533 8 18.75 8C19.3467 8 19.919 8.23705 20.341 8.65901C20.7629 9.08097 21 9.65326 21 10.25C21 10.8467 20.7629 11.419 20.341 11.841C19.919 12.2629 19.3467 12.5 18.75 12.5H16.5Z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>  
        <path d="M12 14.75V12.5H18.75C19.3467 12.5 19.919 12.7371 20.341 13.159C20.7629 13.581 21 14.1533 21 14.75C21 15.3467 20.7629 15.919 20.341 16.341C19.919 16.7629 19.3467 17 18.75 17H14.25C13.6533 17 13.081 16.7629 12.659 16.341C12.2371 15.919 12 15.3467 12 14.75Z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>  
        <path d="M12 17H14.25C14.8467 17 15.419 17.2371 15.841 17.659C16.2629 18.081 16.5 18.6533 16.5 19.25C16.5 19.8467 16.2629 20.419 15.841 20.841C15.419 21.2629 14.8467 21.5 14.25 21.5C13.6533 21.5 13.081 21.2629 12.659 20.841C12.2371 20.419 12 19.8467 12 19.25V17Z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>  
        <path d="M9.75 12.5H12V19.25C12 19.8467 11.7629 20.419 11.341 20.841C10.919 21.2629 10.3467 21.5 9.75 21.5C9.15326 21.5 8.58097 21.2629 8.15901 20.841C7.73705 20.419 7.5 19.8467 7.5 19.25V14.75C7.5 14.1533 7.73705 13.581 8.15901 13.159C8.58097 12.7371 9.15326 12.5 9.75 12.5Z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>  
        <path d="M7.5 12.5V14.75C7.5 15.3467 7.26295 15.919 6.84099 16.341C6.41903 16.7629 5.84674 17 5.25 17C4.65326 17 4.08097 16.7629 3.65901 16.341C3.23705 15.919 3 15.3467 3 14.75C3 14.1533 3.23705 13.581 3.65901 13.159C4.08097 12.7371 4.65326 12.5 5.25 12.5H7.5Z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>  
      </g>    
      <defs>
        <clipPath id="clip0_272_3320">
          <rect width="25" height="24" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

/*
  Clock Icon
*/
export type ClockIconProps = SquareIconProps;

export const ClockIcon = ({
  size,
  color = "#000000",
  strokeWidth = 1.5
}: ClockIconProps): JSX.Element => {
  if (strokeWidth <= 0) return <div></div>;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_272_3320)">
        <path d="M21 13.25C20.6184 17.87 16.7184 21.5 12 21.5C9.61305 21.5 7.32387 20.5518 5.63604 18.864C3.94821 17.1761 3 14.8869 3 12.5C3 7.78156 6.63 3.88156 11.25 3.5" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 7.25V12.5H17.25" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16.0625 3.875C16.0625 4.4618 15.5868 4.9375 15 4.9375C14.4132 4.9375 13.9375 4.4618 13.9375 3.875C13.9375 3.2882 14.4132 2.8125 15 2.8125C15.5868 2.8125 16.0625 3.2882 16.0625 3.875Z" fill={color} stroke={color} strokeWidth={strokeWidth / 12} />
        <path d="M19.4375 6.125C19.4375 6.7118 18.9618 7.1875 18.375 7.1875C17.7882 7.1875 17.3125 6.7118 17.3125 6.125C17.3125 5.5382 17.7882 5.0625 18.375 5.0625C18.9618 5.0625 19.4375 5.5382 19.4375 6.125Z" fill={color} stroke={color} strokeWidth={strokeWidth / 12} />  
        <path d="M20.625 10.625C21.2463 10.625 21.75 10.1213 21.75 9.5C21.75 8.87868 21.2463 8.375 20.625 8.375C20.0037 8.375 19.5 8.87868 19.5 9.5C19.5 10.1213 20.0037 10.625 20.625 10.625Z" fill={color}/>  
      </g>    
      <defs>
        <clipPath id="clip0_272_3320">
          <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

/*
  Lightning Icon
*/
export type LightningIconProps = SquareIconProps;

export const LightningIcon = ({
  size,
  color = "#000000",
  strokeWidth = 1.5
}: LightningIconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_272_3320)">
        <path d="M15 2L13.5 9.5L19.5 11.75L9 23L10.5 15.5L4.5 13.25L15 2Z" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
      </g>    
      <defs>
        <clipPath id="clip0_272_3320">
          <rect width="25" height="24" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

/*
  BitcoinPayroll Icon
*/
export type BitcoinPayrollIconProps = SquareIconProps;

export const BitcoinPayrollIcon = ({
  size,
  color = "#000000",
  strokeWidth = 1.5
}: BitcoinPayrollIconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_272_3320)">
        <path d="M6 5H7.5" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6 19.25H7.5" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9.75 5V2.75" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.75 5V2.75" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>  
        <path d="M9.75 21.5V19.25" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.75 21.5V19.25" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7.5 11.75H14.25C15.2446 11.75 16.1984 12.1451 16.9017 12.8483C17.6049 13.5516 18 14.5054 18 15.5C18 16.4946 17.6049 17.4484 16.9017 18.1517C16.1984 18.8549 15.2446 19.25 14.25 19.25H7.5V5H13.125C14.0201 5 14.8785 5.35558 15.5115 5.98851C16.1444 6.62145 16.5 7.47989 16.5 8.375C16.5 9.27011 16.1444 10.1285 15.5115 10.7615C14.8785 11.3944 14.0201 11.75 13.125 11.75" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
      </g>    
      <defs>
        <clipPath id="clip0_272_3320">
          <rect width="25" height="24" fill="white" transform="translate(0.400391)" />
        </clipPath>
      </defs>
    </svg>
  );
};

/*
 CloseX Icon
*/
export type CloseXIconProps = SquareIconProps;

export const CloseXIcon = ({
  size,
  color = "#000000",
  strokeWidth = 1.5
}: CloseXIconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18.75 5.25L5.25 18.75" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.75 18.75L5.25 5.25" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};
